module.exports = __webpack_public_path__ + "static/media/penha-sc.8582d882.jpg";